(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/score-item.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/score-item.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect;
const PositionDirection = svs.components.marketplaceCompetition.services.constants.highscoreConstants.PositionDirection;
const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  ReactIconButton = _svs$ui.ReactIconButton;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const useCompetitionId = svs.components.marketplaceCompetition.competitionContext.useCompetitionId;
const useCompetitionType = svs.components.marketplaceCompetition.services.hooks.useCompetitionType;
const analytics = svs.components.analytics;
const trackEventOnOverviewTeam = (competition, position, isPersonal) => {
  if (competition.compType) {
    analytics.trackEvent({
      category: competition.compType,
      action: 'overview team',
      opt_label: "".concat(position, "-").concat(isPersonal ? 'Personal' : 'Highscore') 
    });
  }
};
const ScoreItem = _ref => {
  let position = _ref.position,
    direction = _ref.direction,
    name = _ref.name,
    location = _ref.location,
    currentScore = _ref.currentScore,
    totalScore = _ref.totalScore,
    Details = _ref.Details,
    isTeam = _ref.isTeam,
    Initials = _ref.Initials,
    competitionBranding = _ref.competitionBranding,
    _ref$isPersonal = _ref.isPersonal,
    isPersonal = _ref$isPersonal === void 0 ? false : _ref$isPersonal;
  const competitionId = useCompetitionId();
  const competitionType = useCompetitionType(competitionId);
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowingDetails = _useState2[0],
    setIsShowingDetails = _useState2[1];
  const toggleShowingDetails = useCallback(() => {
    setIsShowingDetails(oldValue => !oldValue);
  }, []);
  const containerClassName = ['highscore-item-container'];
  if (isPersonal) {
    containerClassName.push('highscore-item-container-personal');
  }
  if (competitionBranding) {
    containerClassName.push("highscore-item-container-".concat(competitionBranding));
  }
  const shouldShowInitials = isSmall && Boolean(Initials);
  if (shouldShowInitials) {
    containerClassName.push('highscore-item-container-initials');
  }
  const movedUpIcon = useMemo(() => {
    if (direction === PositionDirection.Up) {
      return React.createElement(ReactIcon, {
        className: "highscore-item-position-up",
        color: "fc-green",
        icon: "caret-up",
        size: "100"
      });
    }
    return null;
  }, [direction]);
  const movedDownIcon = useMemo(() => {
    if (direction === PositionDirection.Down) {
      return React.createElement(ReactIcon, {
        className: "highscore-item-position-down",
        color: "fc-red",
        icon: "caret-down",
        size: "100"
      });
    }
    return null;
  }, [direction]);
  useEffect(() => {
    if (isShowingDetails && isTeam) {
      trackEventOnOverviewTeam({
        compType: competitionType
      }, position, isPersonal);
    }
  }, [isShowingDetails, isTeam, isPersonal, position, competitionType]);
  const expAreaPersonalId = "expandable-area-details-".concat(position, "-personal");
  const expAreaId = "expandable-area-details-".concat(position);
  const getAriaLabelExpandable = () => {
    if (isShowingDetails) {
      if (isTeam) {
        return 'Dölj lagets resultat';
      }
      return 'Dölj individuellt resultat';
    }
    if (isTeam) {
      return 'Visa lagets resultat';
    }
    return 'Visa individuellt resultat';
  };
  const getScreenReaderText = () => {
    let screenReaderText;
    if (movedUpIcon) {
      screenReaderText = "Position ".concat(position, ", f\xF6rb\xE4ttrad placering.");
    } else if (movedDownIcon) {
      screenReaderText = "Position ".concat(position, ", ned\xE5tg\xE5ende placering.");
    } else {
      screenReaderText = "Position ".concat(position, ".");
    }
    screenReaderText += " Namn: ".concat(name, ".");
    if (location) {
      screenReaderText += " Ort: ".concat(location, ".");
    }
    screenReaderText += " Senaste omg\xE5ngens resultat: ".concat(currentScore, " po\xE4ng. Totalt resultat: ").concat(totalScore, " po\xE4ng.");
    return screenReaderText;
  };
  return React.createElement("div", {
    className: containerClassName.join(' ')
  }, React.createElement("span", {
    className: "sr-only"
  }, getScreenReaderText()), React.createElement("span", {
    "aria-hidden": "true",
    className: "highscore-item-position"
  }, movedUpIcon, React.createElement("span", {
    "aria-hidden": "true",
    className: "highscore-item-position-number"
  }, position), movedDownIcon), Boolean(Initials) && isSmall && React.createElement(Initials, null), !location && React.createElement("span", {
    "aria-hidden": "true",
    className: "highscore-item-full-name highscore-item-full-name-oneline"
  }, name), location && React.createElement(React.Fragment, null, React.createElement("span", {
    "aria-hidden": "true",
    className: "highscore-item-full-name"
  }, name), React.createElement("span", {
    "aria-hidden": "true",
    className: "highscore-item-location"
  }, location)), React.createElement("span", {
    "aria-hidden": "true",
    className: "highscore-item-currentscore"
  }, currentScore), React.createElement("span", {
    "aria-hidden": "true",
    className: "highscore-item-totalscore"
  }, totalScore), React.createElement("span", {
    className: "highscore-item-more"
  }, React.createElement(ReactIconButton, {
    "aria-controls": isPersonal ? expAreaPersonalId : expAreaId,
    "aria-expanded": isShowingDetails !== null && isShowingDetails !== void 0 ? isShowingDetails : undefined,
    "aria-label": getAriaLabelExpandable(),
    onClick: toggleShowingDetails
  }, React.createElement(ReactIcon, {
    icon: isShowingDetails ? 'menu-up' : 'menu-down',
    size: "100"
  }))), isShowingDetails && React.createElement("div", {
    className: "highscore-item-details-container",
    id: isPersonal ? expAreaPersonalId : expAreaId
  }, React.createElement(Details, null)));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.ScoreItem', ScoreItem);

 })(window);